import { groq } from 'next-sanity';
import { z } from 'zod';

import { cardButton, SanityCardButton } from './buttonRow';

export const SanityPolicyEngineMetric = z.object({
  _key: z.string(),
  number: z.string(),
  label: z.string(),
});
export type SanityPolicyEngineMetric = z.infer<typeof SanityPolicyEngineMetric>;

export const SanityPolicyEngineAnimation = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('policyEngineAnimation'),
  _key: z.string(),
  title: z.string(),
  headline: z.string().optional().nullable(),
  buttons: z.array(SanityCardButton).optional().nullable(),
  buttonPosition: z.enum(['above', 'below']).optional().nullable(),
  metrics: z.array(SanityPolicyEngineMetric).optional().nullable(),
});
export type SanityPolicyEngineAnimation = z.infer<
  typeof SanityPolicyEngineAnimation
>;

export const policyEngineAnimation = groq`{
  title,
  headline,
  buttons[] ${cardButton},
  buttonPosition,
  metrics[] {
    _key,
    number,
    label,
  },
}`;
